import { Dialog, DialogTitle, Box, Stack, Button, Alert } from '@mui/material';
import { Formik } from 'formik';
import * as yup from 'yup';
import { MFTextField } from '../../lib/formik';
import { emailRegex } from '../../utils/regex';

type Props = {
  open: boolean;
  digioId?: string;
  initialEmail?: string;
  initialPhone?: string;
  onSuccess: (data: { emailId: string; phone: string; digioId: string }) => Promise<void> | void;
};

export function KRAAlertDialog({
  open,
  digioId = '',
  initialEmail = '',
  initialPhone = '',
  onSuccess,
}: Props): JSX.Element {
  console.log('KRAAlertDialog rendered with:', { open, digioId, initialEmail, initialPhone });
  const validationSchema = yup.object({
    emailId: yup.string().matches(emailRegex, 'Invalid Email ID').required('Email is required'),
    phone: yup
      .string()
      .matches(/^[6-9]\d{9}$/, 'Invalid mobile number')
      .required('Mobile number is required'),
  });

  return (
    <Dialog
      open={open}
      fullWidth
      maxWidth="sm"
      disableEscapeKeyDown
      PaperProps={{
        sx: {
          alignSelf: 'flex-start',
          mt: 4,
        },
      }}>
      <DialogTitle>KYC Action Required</DialogTitle>

      <Formik
        initialValues={{ emailId: initialEmail, phone: initialPhone, digioId }}
        validationSchema={validationSchema}
        onSubmit={async (values, helpers) => {
          try {
            await onSuccess(values);
          } finally {
            helpers.setSubmitting(false);
          }
        }}>
        {({ handleSubmit, isSubmitting }) => (
          <Box component="form" onSubmit={handleSubmit} p={3}>
            <Alert severity="warning" sx={{ mb: 2 }}>
              Your KYC is currently <strong>On Hold / Not Completed</strong>. Please provide the
              details below to continue.
            </Alert>

            <MFTextField label="Email ID" name="emailId" placeholder="Enter Email ID" required />

            <MFTextField
              label="Mobile Number"
              name="phone"
              placeholder="Enter Mobile Number"
              required
            />

            <Stack direction="row" justifyContent="flex-end" mt={3}>
              <Button type="submit" variant="contained" disabled={isSubmitting}>
                Continue
              </Button>
            </Stack>
          </Box>
        )}
      </Formik>
    </Dialog>
  );
}
